import Api from "./Api";
import Csrf from "./Csrf";

export default {
    
  async index() {
    await Csrf.getCookie();

    return Api.get("/virtual_api");
  },
    
  async store(data) {
    await Csrf.getCookie();

    return Api.post("/virtual_api",data);
  },
  
  async delete(id) {
    await Csrf.getCookie();

    return Api.delete("/virtual_api/"+id);
  },
	
};